export const RESERVED_PATH_SEGMENTS = new Set([
  "login",
  "signup",
  "verify-your-email",
  "public-menu",
  "public-menus",
  "verify",
  "error",
  "internal",
  "forget-password",
  "reset-password",
]);

export function isReservedPathSegment(
  segment: string | undefined | null,
): boolean {
  return !segment || RESERVED_PATH_SEGMENTS.has(segment);
}
